module.exports = __webpack_public_path__ + "static/media/rexoz shot 4.c1f2ff78.webp";